(function () {
  function sizeUrl(u, size) {
    if (!u) return u;
    return String(u).replace(/respimgsize/g, size || '800x');
  }
  function isHome() {
    return document.body && document.body.classList.contains('pageindex');
  }
  function hydrateImg(img) {
    if (!img) return;
    var main = img.getAttribute('data-mainimage');
    var src = img.getAttribute('src');
    if (main && (!src || src === '' || src.indexOf('data:') === 0)) {
      img.setAttribute('src', sizeUrl(main, '800x'));
    }
    if (isHome()) {
      img.style.opacity = '1';
      img.style.visibility = 'visible';
      img.classList.add('lazyloaded');
      img.loading = 'eager';
    }
  }
  function hydrate() {
    document.querySelectorAll('img.lazyload, img[data-mainimage]').forEach(hydrateImg);
    document.querySelectorAll('.iron-hs__img').forEach(function (img) {
      img.loading = 'eager';
      img.style.opacity = '1';
      img.style.visibility = 'visible';
    });
  }
  function boot() {
    hydrate();
    setTimeout(hydrate, 200);
    setTimeout(hydrate, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', hydrate);
  window.addEventListener('pageshow', function () { setTimeout(hydrate, 50); });
})();
